const ggrReport = {
  INDEX: '/ggr-report',
}

export default ggrReport
